import { useEffect } from "react";

const useClickjackingDefence = () => {

  useEffect(() => {
    if (window.top !== window) {
      document.body.innerHTML = "";
      throw new Error("Clickjacking attack detected");
    }
  }, []);
};

export default useClickjackingDefence;
